import React from 'react'

export default function PercentageAnswerChoice ({letter, percent, correct}) {
  let style = {width: `${percent}px`}
  if (percent == 0) {
    style = {width: '1px', opacity: 0}
  }
  let cor = ''
  if (correct) {
    cor = ' correct'
  }

  return (
    <div className={`answer-choice${cor}`}>
      {
        correct
        ? <span className="checkmark">
            <i className="fas fa-check"></i>
          </span>
        : null
      }
      <span className="answer-choice-letter">{`${letter}.`}</span>
      <span className="percent-answered-bar" style={style}></span>
      <span className="percent-answered-number">{`${percent}%`}</span>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessPrint/AnswerPercentage/PercentageAnswerChoice.js